import React, { useEffect } from 'react'

export const ShopLearn = ({ containerObject, templateName, contentId, dataZone }) => {

    useEffect(() => {
        window.addEventListener('scroll', function () {
           
            if (window.scrollY > 0) {
                console.log("height", document.getElementById("sticky-subnav__inner").offsetTop)
                if (document.getElementById("sticky-subnav__inner").offsetTop == 0) {
                    document.getElementById("sticky-subnav__inner").classList.add("sticky-subnav__inner--sticky")
                }
            } else {
                document.getElementById("sticky-subnav__inner").classList.remove("sticky-subnav__inner--sticky")
            }
        });
    }, [])

    function scrollToView(id) {
        const scroll = document.querySelector(`.${id}`);
        console.log("scroll", scroll)
        if (scroll != undefined && scroll != null) {
            scrollTop(scroll.offsetTop)
        }
    }

    const scrollTop = (top) => {
        var height = document.getElementById("sticky-subnav__inner").offsetHeight;
        var length = top - height
        window.scrollTo({
            top: parseInt(length),
            behavior: 'smooth'
        });
    };

    return (<>
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`} >
            <nav class="sub-navigation pt-5 pb-5">
                <div id="sticky-subnav__inner" class="sticky-subnav__inner">
                    <ul className='list-unstyled'>
                        <li class="tab-link shop "><a style={{ cursor: "pointer" }} class="kandha_navigation_btn active" onClick={() => scrollToView("shop-scroll-id")}>Shop</a></li>
                        <li class="tab-link learn"><a style={{ cursor: "pointer" }} class="kandha_navigation_btn" onClick={() => scrollToView("learn-scroll-id")}>Learn</a></li>
                    </ul>
                </div>
            </nav>
        </div>
    </>
    )
}
